import { http } from '../index';

export const getUserCompliance = userId => http.get(`/compliance/users/${userId}`).then(res => res.data);

export const getUserJobTaskCompliance = (userId, jobTaskId) =>
  http.get(`/compliance/users/${userId}/job-tasks/${jobTaskId}`).then(res => res.data);

export const evaluateUserCompliance = userId => http.post(`/compliance/users/${userId}/evaluate`).then(res => res.data);

export const recalculateAllCompliance = () => http.post('/compliance/recalculate-all').then(res => res.data);

export const getFutureImpact = (userId, jobTaskId, futureVersionId) =>
  http.get(`/compliance/users/${userId}/job-tasks/${jobTaskId}/future-impact/${futureVersionId}`).then(res => res.data);
